// extracted by mini-css-extract-plugin
export default {"Container":"Syxf6rBrpo1DlVKzzN8o","BreadCrumbs":"i8zKLwvIa9l4lsNYovBU","Title":"FyVXy5vXlIfKvjzq54ww","Form":"PwLyHbq7Poy9bLODCpVU"};